export const APP_NAME = 'subscription-wizard';
export const PACKAGE_NAME = '@ori/subscription-wizard';
export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;

export * from './defaultTranslations';

export * from './profile-element-settings';
